import ReactGA from 'react-ga4';

export const clickEvent = (data) => {
    ReactGA.event(data);
}

export const pageViewEvent = (data) => {
    ReactGA.send(data);
}